import React, { useState, useCallback } from "react";

import styled from "styled-components";

import cross from "icons/cross";
import warning from "icons/warning";
import done from "icons/done";

import { MessageType } from "model/dictionary";

//import Spinner from "components/Spinner";
import Modal from "components/Modal";

export const AlertContext = React.createContext();

const GetIcon = (type) => {
  switch (type) {
    case MessageType.WAITING:
      return <Spinner size="medium" position="left" />;
    case MessageType.DANGER:
      return <IconDanger />;
    case MessageType.WARNING:
      return <IconWarning />;
    case MessageType.SUCESSFULL:
      return <IconSucessfull />;
    default:
      break;
  }
};

export const AlertProvider = ({ children }) => {
  const [show, setShowAlert] = useState(false);
  const [type, setType] = useState("gray");
  const [content, setContent] = useState("Procesando solicitud");

  const showAlert = useCallback((type, content, duration, callback) => {
    setShowAlert(true);
    setType(type);

    setContent(content);

    duration &&
      setTimeout(() => {
        setShowAlert(false);
        callback && callback();
      }, duration);
  }, []);

  const hideWaiting = useCallback(() => {
    setShowAlert(false);
  }, []);

  const showWaiting = useCallback((content) => {
    setShowAlert(true);
    setType(MessageType.WAITING);
    setContent(content);
  }, []);

  return (
    <AlertContext.Provider
      value={{
        showAlert,
        hideWaiting,
        showWaiting,
      }}
    >
      <Modal
        locked
        onClose={() => {
          setShowAlert(false);
        }}
        open={show}
      >
        <Container accent={ACCENT_BY_TYPE[type] || ACCENT_BY_TYPE[MessageType.WAITING]}>
          <div className="icon-wrapper">{GetIcon(type)}</div>
          <p>{content}</p>
        </Container>
      </Modal>
      {children}
    </AlertContext.Provider>
  );
};

// Layout: icono centrado arriba en un círculo de color tenue + texto debajo.
// Padding interno generoso. Animación sutil de pop-in al aparecer.
const Container = styled.div`
  min-width: 32rem;
  max-width: 42rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
  padding: 3.2rem 3rem;
  text-align: center;
  animation: alert-pop 280ms cubic-bezier(0.34, 1.2, 0.64, 1) both;

  @keyframes alert-pop {
    from {
      transform: scale(0.85);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  .icon-wrapper {
    width: 7.2rem;
    height: 7.2rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ accent }) => accent}1A; /* color + 10% opacity hex */
    color: ${({ accent }) => accent};
  }

  p {
    margin: 0;
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 1.4;
    color: #353535;
  }
`;

const IconDanger = styled(cross)`
  width: 3.6rem;
  height: 3.6rem;
`;

const IconWarning = styled(warning)`
  width: 3.6rem;
  height: 3.6rem;
`;

const IconSucessfull = styled(done)`
  width: 3.6rem;
  height: 3.6rem;
`;

const ACCENT_BY_TYPE = {
  [MessageType.SUCESSFULL]: "#339900",
  [MessageType.DANGER]: "#D8000C",
  [MessageType.WARNING]: "#E69500",
  [MessageType.WAITING]: "#08255A",
};

const Spinner = () => {
  return (
    <StyledSpinner>
      <div className="ring" />
    </StyledSpinner>
  );
};

const StyledSpinner = styled.div`
  width: 5.6rem;
  height: 5.6rem;
  display: flex;
  align-items: center;
  justify-content: center;

  .ring {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 4px solid rgba(8, 37, 90, 0.15);
    border-top-color: #08255a;
    border-right-color: #006edf;
    animation: spinner-rotate 900ms linear infinite;
  }

  @keyframes spinner-rotate {
    to {
      transform: rotate(360deg);
    }
  }
`;
